<template>
  <nav class="TopicFilterComponent colorBlock">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-md-4 col-lg-3 topicSidebar">
          <h2 class="mobileOnly">{{ heading }}</h2>

          <button id="allFiltersToggle" @click="toggleAllFilters" :class="mobileFilters">
            All Filters <i class="fa fa-chevron-down"/>
          </button>

          <div id="topicFilterContainer" :class="mobileFilters">
            <AppliedFilters
              :filters="appliedFilters"
              @remove="removeFilter"
            />

            <h2>All Filters</h2>

            <KeywordSearch
              :keywords="checkedFilters.keywords"
              @add="addKeyword"
            />
            <Checkboxes
              :title="'Topic'"
              :options="filters.topics"
              v-model="checkedFilters.topics"
            />
            <Checkboxes
              :title="'Department'"
              :options="filters.departments"
              v-model="checkedFilters.departments"
              :limit="4"
            />
            <Checkboxes
              :title="'When action is planned for'"
              :options="filters.timeline"
              v-model="checkedFilters.timelines"
              :limit="4"
            />
          </div>
        </div>
        <div class="col-xs-12 col-md-8 col-lg-9 topics">
          <CardSet :cards="filteredCards" :heading="heading" :page="page" @clear="clearAllFilters" />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import CardSet from "@/components/CardSet.vue";
import KeywordSearch from "@/components/KeywordSearch.vue";
import Checkboxes from "@/components/Checkboxes.vue";
import AppliedFilters from "@/components/AppliedFilters.vue";

export default {
  name: "FilterSection",
  props: {
    actions: Array,
    filters: Object,
    page: Number,
    prefilter: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checkedFilters: {
        topics: [],
        departments: [],
        timelines: [],
        keywords: [],
      },
      mobileFilters: false,
    };
  },
  created() {
    this.applyPrefilter()
  },
  watch: {
    prefilter() {
      this.applyPrefilter()
    }
  },
  computed: {
    heading() {
      let cards = this.filteredCards.length,
          allCards = this.actions.length,
          heading = (cards != allCards) ? `${ cards }/${ allCards }` : allCards

      heading += (cards == 1) ? ' Action' : ' Actions'

      return heading
    },
    appliedFilters() {
      return [
        ...this.checkedFilters.topics,
        ...this.checkedFilters.departments,
        ...this.checkedFilters.timelines,
        ...this.checkedFilters.keywords,
      ];
    },
    searchIndex() {
      return this.actions.map(action => { 
        let index = ''

        for (const property in action) {
          index += ` ${action[property]} `
        }

        return {
          id : action.id,
          index : index.toLowerCase()
        }
      })
    },
    filteredCards() {
      let cards = this.actions,
        topics = this.checkedFilters.topics,
        departments = this.checkedFilters.departments,
        timelines = this.checkedFilters.timelines,
        keywords = this.checkedFilters.keywords;

      if (topics.length > 0) {
        cards = cards.filter((x) =>
          topics.includes(
            x.community_outcome_1_title || x.community_outcome_2_title
          )
        );
      }

      if (departments.length > 0) {
        cards = cards.filter((x) => departments.includes(x.department));
      }

      if (timelines.length > 0) {
        cards = cards.filter((x) => timelines.some(timeline => x.years.includes(timeline)));
      }

      if (keywords.length > 0) {
        for (const keyword of keywords) {
          // console.log('filtering on keyword: ', keyword)
          cards = cards.filter((x) => {
              let searchIndex = this.searchIndex.find(item => item.id == x.id)

              return searchIndex?.index?.indexOf(keyword.toLowerCase()) > -1
          });
        }
      }

      return cards;
    },
  },
  components: {
    CardSet,
    KeywordSearch,
    Checkboxes,
    AppliedFilters,
  },
  methods: {
    toggleAllFilters() {
      this.mobileFilters = (this.mobileFilters == 'active') ? '' : 'active'
    },
    removeFilter(filter) {
      for (const [key, filterSet] of Object.entries(this.checkedFilters)) {
        // console.log(`${key}: ${filterSet}`);

        if (filterSet.includes(filter)) {
          this.checkedFilters[key] = filterSet.filter((x) => x != filter);
        }
      }
    },
    clearAllFilters() {
      console.log('clearing all filters')

      console.log(this.filterReset)

      this.checkedFilters = {
        topics: [],
        departments: [],
        timelines: [],
        keywords: [],
      }
    },
    addKeyword(keyword) {
      this.checkedFilters.keywords.push(keyword);
    },
    applyPrefilter() {
      if (this.prefilter.length > 0) {
        const removeSpecialChars = string => {
          return string.replace(/"|\/|_|-|~|,|\.|#/g, ' ').toLowerCase().trim();
        }
        // console.log(removeSpecialChars('criminal-justice'))
        // console.log(removeSpecialChars('Criminal Justice'))
        // console.log('Prefilter Prop: ', this.prefilter)

        // Loop through all the filter collections
        for (const [key, filterSet] of Object.entries(this.filters)) {
          // Reset checked filters
          this.checkedFilters[key] = []

          // Loop through all filters in a collection
          for (const filter of filterSet) {
            // Check to see if the prefilter exists in the filter collection
            if (removeSpecialChars(filter) == removeSpecialChars(this.prefilter)) {
              // Add the filter to the checked list
              this.checkedFilters[key].push(filter)
            }
          }
        }
      }
    }
  },
};
</script>

<style lang="scss">
.TopicFilterComponent.colorBlock {
  border-bottom: 1px solid #ccc;

  @media (max-width: 991px) {
    padding-top:0px !important;
    
    #topicFilterContainer {
      background:#f1f1f1;
      border:0;
      padding: 5px 20px 20px;
      display: none;

      &.active {
        display: block;
      }
    }
  }
}

.mobileOnly {
  @media (min-width:992px) {
    display: none;
  }
}

#allFiltersToggle {
  display: none;

  @media (max-width: 991px) {
    display: block;
    width: calc(100% + 12px);
    margin: 10px -5px 0;
    background: #fff;
    border: 1px solid #003da5;
    color: #003da5;
    height: 50px;
    font-weight: bold;

    i,svg {
      margin-left: 5px;
    }

    &.active {
      i,svg {
        transform: rotate(180deg);
      }
    }
  }
}

#topicFilterContainer {
  padding-right:35px;

  @media (max-width: 991px) {
    width: calc(100% + 12px);
    margin: 0 -5px;
  }

  h2 {
    font-size: 24px;
  }
  h3 {
    font-size: 16px;
    font-family: "Open Sans", sans-serif;
  }
  .checkbox {
    height:40px;
  }

  input[type=checkbox]+label {
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;

    &:before {
      min-width: 24px;
      margin-left: -40px;
      margin-bottom: 0px;
    }
  }

  button.showAllFilters {
    background: transparent;
    border:0;
    font-weight: bold;
    color:#003da5;
  }
}
</style>